import { render, staticRenderFns } from "./VehicleSocketTable.vue?vue&type=template&id=031a6954"
import script from "./VehicleSocketTable.vue?vue&type=script&lang=js"
export * from "./VehicleSocketTable.vue?vue&type=script&lang=js"
import style0 from "./VehicleSocketTable.vue?vue&type=style&index=0&id=031a6954&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports